<template>
  <div class="nav">
    <div class="content">
      <div>
        <img src="@/assets/pingworthLogo.png" alt="">
      </div>
      <el-dropdown class="avatar-container">
        <div class="avatar-wrapper">
          <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <div style="display: inline-block;position: relative;top: -2px;font-size: 16px;">
            <span>{{ userName }}</span>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div style="line-height: 34px;" @mousemove="changeShowLangSelect(true)" @mouseleave="changeShowLangSelect(false)">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 7.99989C16 3.57067 12.4293 0 7.99989 0C3.57067 0 0 3.57067 0 7.99989C0 12.384 3.57067 15.9998 7.95482 15.9998H8.04518C12.4293 16 16 12.3842 16 7.99989ZM2.21461 12.5197C1.31078 11.3446 0.723108 9.89834 0.632746 8.31627H4.20342C4.20342 9.03938 4.29378 10.2598 4.61016 11.4802C3.66104 11.7062 2.75699 12.0226 2.21461 12.5197ZM2.16953 3.48031C2.71192 3.97741 3.61596 4.33907 4.61016 4.56508C4.33907 5.78549 4.2485 6.96062 4.2485 7.68373H0.678032C0.723108 6.10166 1.26549 4.65544 2.16953 3.48031ZM13.8305 3.48031C14.7345 4.65544 15.2767 6.10166 15.3673 7.68373H11.7966C11.7966 6.96062 11.7062 5.78549 11.3898 4.56508C12.3842 4.33907 13.2881 3.97741 13.8305 3.48031ZM11.1638 7.68352H8.31627V4.88124C9.03938 4.88124 9.89813 4.79088 10.7569 4.65523C11.0735 5.87565 11.1185 7.05078 11.1638 7.68352ZM8.31627 4.2485V0.81347C9.4914 1.44622 10.1694 2.75699 10.5762 4.06756C9.80777 4.20342 8.9943 4.2485 8.31627 4.2485ZM7.68352 0.81347V4.2485C7.00549 4.2485 6.19202 4.15813 5.42363 4.06756C5.78528 2.75699 6.50839 1.4915 7.68352 0.81347ZM7.68352 4.88124V7.68352H4.83617C4.83617 7.05078 4.92653 5.87565 5.2429 4.70052C6.14694 4.83617 7.05078 4.88124 7.68352 4.88124ZM4.83617 8.31627H7.68373V11.1638C7.05099 11.1638 6.19223 11.2091 5.24311 11.3898C4.92653 10.1244 4.88124 8.94922 4.83617 8.31627ZM7.68352 11.7966V15.1863C6.50839 14.5536 5.83036 13.2881 5.42363 11.9773C6.19202 11.8419 7.0057 11.7966 7.68352 11.7966ZM8.31627 15.1863V11.7966C8.9943 11.7966 9.80777 11.8869 10.5762 12.0226C10.1694 13.2881 9.4914 14.5536 8.31627 15.1863ZM8.31627 11.1638V8.31627H11.1638C11.1638 8.94901 11.0735 10.1241 10.7571 11.3896C9.89834 11.2542 8.9943 11.1638 8.31627 11.1638ZM11.7966 8.31627H15.3673C15.2769 9.89813 14.7345 11.3446 13.7854 12.5197C13.243 12.0226 12.3392 11.7062 11.3898 11.4802C11.6611 10.2598 11.7513 9.03959 11.7966 8.31627ZM13.4237 3.02829C12.9717 3.43503 12.1582 3.7514 11.2542 3.93233C10.8925 2.7572 10.3051 1.58207 9.35596 0.768394C10.9378 1.03948 12.339 1.85316 13.4237 3.02829ZM6.64404 0.768394C5.69492 1.58186 5.10725 2.75699 4.7458 3.97741C3.84176 3.7514 3.02829 3.43503 2.57627 3.02829C3.66104 1.85316 5.06218 1.03948 6.64404 0.768394ZM2.62156 13.017C3.07358 12.6103 3.88705 12.2939 4.79109 12.113C5.15275 13.2881 5.74021 14.4632 6.64425 15.2316C5.06218 14.9605 3.66104 14.1468 2.62156 13.017ZM9.35596 15.2316C10.3051 14.4181 10.8475 13.2881 11.2091 12.113C12.113 12.2939 12.9266 12.61 13.3787 13.017C12.339 14.1468 10.9378 14.9605 9.35596 15.2316Z"
            fill="#333333"/>
        </svg>
        <span>{{ lang }}</span>
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0.707107L0.707107 0L6.36396 5.65685L5.65685 6.36396L0 0.707107Z" fill="#333333"/>
          <path d="M10.6064 7.55191e-05L11.3136 0.707182L5.65685 6.36396L4.94959 5.65693L10.6064 7.55191e-05Z"
                fill="#333333"/>
        </svg>
      </div>
      <div class="lang-select" @mousemove="changeShowLangSelect(true)" @mouseleave="changeShowLangSelect(false)"
           v-show="showLangSelect">
        <div :class="{'lang-select-active': $i18n.locale=='zh-CN'}" @click="changeLang('zh-CN')">中文</div>
        <div :class="{'lang-select-active': $i18n.locale=='en-US'}" @click="changeLang('en-US')">English</div>
      </div>
      <el-switch v-if="developer" class="switch-title1" v-model="developerChecked" inactive-text="产研部"
                 @change="changeSwitch"></el-switch>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      showLangSelect: false,
      developerChecked: localStorage.developerChecked == 'true',
      visible: false
    }
  },
  computed: {
    lang() {
      return this.$i18n.locale === 'zh-CN' ? '中文' : 'English'
    },
    ...mapGetters([
      'avatar',
      'userName',
      'developer'
    ])
  },
  methods: {
    changeLang(val) {
      this.$i18n.locale = val
      localStorage.lang = val
    },
    changeShowLangSelect(val) {
      this.showLangSelect = val
    },
    changeShowPop(val) {
      this.visible = val
    },
    popClose() {
      this.changeShowPop(false)
    },
    popConfirm() {
      this.changeShowPop(false)
    },
    async logout() {
      await this.$store.dispatch('logout')
      this.$router.push(`/login`)
    },
    changeSwitch(val) {
      localStorage.developerChecked = val
      this.$store.commit('changeDeveloperChecked', val)
    }
  }
}
</script>

<style lang="less">
@import '../styles/index.less';

.nav {
  width: 100%;
  border-bottom: 1px solid #E8E8E8;
  background: #fff;
  z-index: 2
}

.content {
  .content();
  padding: 30px 0;
  display: flex;
  position: relative;

  & > div:nth-child(1) {
    flex-grow: 1;

    & > img {
      width: 213px;
      height: 30px;
    }
  }

  & > div:nth-child(2) {
    display: flex;
    align-items: center;
    margin-right: 10px;

    & > span {
      margin: 0 10px;
      color: #333;
      font-size: 14px;
      line-height: 19px;
    }
  }

  .lang-select {
    position: absolute;
    right: 0px;
    top: 63px;
    width: 100px;
    padding: 5px 0;
    background: #fff;
    border-radius: 4px;
    text-align: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    & > div {
      padding: 8px 0px;
      font-size: 12px;
      color: #333;
      cursor: pointer;

      &:hover {
        background: rgba(255, 61, 72, 0.1);
      }
    }

    &-active {
      color: #ff3d48 !important;
      background: rgba(255, 61, 72, 0.1);
    }
  }

  .switch-title {
    position: absolute;
    right: 150px;
    top: 32px;
    font-size: 14px;
    color: #333;
    height: 60px;
  }

  .switch-title1 {
    right: 175px;
    top: 37px;
    font-size: 14px;
    color: #333;
    display: inline-block;
    position: absolute;
  }

  .user-avatar {
    width: 20px;
    height: 20px;
    border-radius: 10px;
    margin-top: 2px;
  }

  .switch-select {
    position: absolute;
    right: 120px;
    top: 42px;
  }

  .el-switch__label.is-active {
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav.vue